import React from 'react';
import './LoginPage.css';

const LoginPage = ({ onLogin }) => {
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-content">
          <div className="login-left">
            <div className="login-logo">
              <img src="/images/elef_logo.png" alt="ELEF89 Logo" className="actual-logo" />
            </div>
            <h1>Welcome to ELEF89</h1>
            <p>Sign in with your Google account to get started.</p>
            <button className="google-login-button" onClick={onLogin}>
              <img 
                src="https://www.google.com/favicon.ico" 
                alt="Google" 
                className="google-icon"
              />
              Continue with Google
            </button>
          </div>
          <div className="login-right">
            <div className="welcome-image"></div>
            <div className="welcome-message">
              <h2>Smart Deployment Starts Here <span className="heading-icon">🚀</span></h2>
              <p>Your all-in-one platform for app delivery, simplified.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 